import React from 'react';
import { typography } from '../../styles/typography';

/**
 * Horizontal underline-style tab bar (active tab: bold + green underline + light gradient).
 */
const UnderlineTabBar = ({
  title,
  tabs = [],
  activeTabId,
  onTabChange,
  className = '',
}) => {
  return (
    <div className={`flex flex-col gap-3 w-full ${className}`}>
      {title && (
        <h3 className={typography.h3} style={{ color: '#000000' }}>
          {title}
        </h3>
      )}
      <div className="flex flex-col w-full">
        <div className="flex flex-wrap items-end gap-0 border-b border-zinc-200">
          {tabs.map(tab => {
            const isActive = activeTabId === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => onTabChange?.(tab.id)}
                className={`relative px-4 py-2.5 text-sm font-['Open_Sans'] transition-colors ${
                  isActive
                    ? 'font-bold text-black bg-gradient-to-b from-[#E8F7F2] to-transparent'
                    : 'font-normal text-gray-600 hover:text-black'
                }`}
              >
                {tab.label}
                {isActive && (
                  <span
                    className="absolute bottom-0 left-0 right-0 h-1 bg-[#1B6B52] rounded-t-sm"
                    aria-hidden
                  />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default UnderlineTabBar;
